import React, { Component } from "react";
import PropTypes from "prop-types";
import SectionWrapper from "~/scripts/components/SectionWrapper";
import LeftyRighty from "../LeftyRighty";
import Searching from "../products/Searching";

class Articles extends Component {
    static propTypes = {
        data: PropTypes.array,
        loading: PropTypes.bool
    };

    renderArticle = (
        { id, title, url, summary, imageUrl, project, applications },
        index
    ) => {
        const direction = index % 2 ? "left" : "right";

        return (
            <SectionWrapper key={id} bgColor="dark-blue" bigSpacing>
                <LeftyRighty
                    direction={direction}
                    theme="light"
                    url={url}
                    title={title}
                    text={summary}
                    imageUrl={imageUrl}
                    desc={[
                        {
                            label: "Project",
                            value: project
                        },
                        {
                            label: "Applications",
                            value: applications ? applications.join(", ") : ""
                        }
                    ]}
                    button="View case study"
                />
            </SectionWrapper>
        );
    };

    render() {
        const { data, loading, pagination } = this.props;

        return (
            <>
                {data.map(this.renderArticle)}
                {loading && (
                    <SectionWrapper bgColor="dark-blue" bigSpacing>
                        <Searching theme="light" />
                    </SectionWrapper>
                )}
                {!loading && pagination && pagination.total === 0 && (
                    <div className="no-results">
                        <div className="no-results__message">
                            Sorry, there are no results that match your query.
                        </div>
                    </div>
                )}
            </>
        );
    }
}

export default Articles;



// WEBPACK FOOTER //
// ./public/assets/scripts/components/case-studies/Articles.js